import React, {Component} from 'react';
import axios from 'axios';
import {ToastContainer, ToastStore} from 'react-toasts';
import Webcam from "react-webcam";
import auth0Client from '../Auth';
import {SERVER_URL}  from '../Constants';
import Toggle from "react-toggle-component"
import { Multiselect } from 'multiselect-react-dropdown';
import Cookies from 'universal-cookie';


const WIDTH = 500;
const HEIGHT = 500;
const COOKIE_DEFAULT_DEVICE_ID = 'defaultDeviceId';

const cookies = new Cookies();
//const canvasRef = useRef(null);
class Camera extends Component {
    constructor(props) {
      super(props);
      let defaultDeviceId= cookies.get(COOKIE_DEFAULT_DEVICE_ID);
        this.state={
            mediaDevices:[],
            deviceId:(defaultDeviceId)? defaultDeviceId : '',
            base64Image:undefined,
            keywords:'',
            title:'',
            protectFlag:false,
            scale:1,
            kewordList:[],
            selectedKeyWordList:[],
        }
        this.canvasRef = React.createRef();
        //const canvas = canvasRef.current
        //const context = canvas.getContext('2d')
    }

    async componentDidMount(){
       this.loadMediaDevices();
    }
    loadMediaDevices=async()=>{
       try{
        let devices = [];
        devices = await navigator.mediaDevices.enumerateDevices();
        let videoDevices =  devices.filter(({ kind }) => kind === "videoinput");
        //console.log(videoDevices)
        this.setState({
            mediaDevices:videoDevices
        })

       }catch(e){
            console.log(e.message);
       } 
    }
    onChangeMediaDevice=(event)=>{
        const target = event.target;
        const value = target.value;

        this.clear();
        // change the webCam
        this.setState({
            deviceId:value
        },()=>{
            cookies.set(COOKIE_DEFAULT_DEVICE_ID, value, { path: '/' });
        })

    }
    renderDeviceList=()=>{
        if (this.state.mediaDevices){
            return(

                <select onChange={this.onChangeMediaDevice} type="text" className="custom-select" value={this.state.deviceId}>
                    {this.state.mediaDevices.map((device, key) => (
                        <option key={device.deviceId} value={device.deviceId}>{device.label}</option>
                               
                  ))}

                </select>
               
            )
        }else{
           return(<select></select>)
        }
    }

    // Send image down for processing at the BOUNTE API
    processPhoto=async()=>{
      //  processImage
      
      try{
        await axios.post(`${SERVER_URL}/LostItems/processImage`, {
            base64:this.state.base64Image,
            protectMode: this.state.protectFlag
            }, {
                headers: { 
                'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                'venueId': auth0Client.getActiveVenuedId()
                }
            })
            .then((res)=>{ 
               
                if (res.status===200){
                    if (res.data.mlResults && res.data.mlResults.length >0){
                        this.processMLResults(res.data)
                    }
                    
                }else{
                    ToastStore.error('an error occured processing your photo'); 
                }
            });
      }catch{
        ToastStore.error('an error occured processing your photo');
      }
       
        
     
     
    }


    processMLResults=(results)=>{
        let keywords = [];
        let title = [];

        if (!results.mlResults) {
            this.setState({keywords:keywords.join(','), title:title.join(',')});
            return;
        }
        let mlresult = results.mlResults[0];
        try{
            // Get the Objects
            if (mlresult.localizedObjectAnnotations){
                for (var i=0; i < mlresult.localizedObjectAnnotations.length; i++){
                    if (mlresult.localizedObjectAnnotations[i].score > .60){
                        keywords.push(mlresult.localizedObjectAnnotations[i].name);
                        title.push(mlresult.localizedObjectAnnotations[i].name);
                    }
                  
                }
            }
             // Get the labels
            if (mlresult.labelAnnotations){
                for (var l=0; l < mlresult.labelAnnotations.length; l++){
                    if (mlresult.labelAnnotations[l].score > .70){
                        keywords.push(mlresult.labelAnnotations[l].description);
                    }
                   
                }
            }
             // Get the Logos
             if (mlresult.logoAnnotations){
                for (var n=0; n < mlresult.logoAnnotations.length; n++){
                    if (mlresult.logoAnnotations[n].score > .70){
                        keywords.push(mlresult.logoAnnotations[n].description);
                    }
                   
                }
            }

            this.setState({keywords:keywords.join(','), title:title.join(',')});

            // Protect mode needs keywords from the main text
            let protectKeywords = [];
            if (this.state.protectFlag && mlresult.textAnnotations){
                const imageText = mlresult.textAnnotations[0].description;
                if (imageText){
                    const textLines = imageText.split('\n');
                    for (var t=0; t<textLines.length; t++){
                        if (textLines[t]!=='') {
                            protectKeywords.push(textLines[t]);
                        }
                    }
                  
                }
            }
            this.setState({kewordList:protectKeywords});
            if(this.state.protectFlag){
                 this.renderTextBoundingBoxes(mlresult);
            }else{
                this.renderBoundingBoxes(mlresult);
            }

        }catch(e){
            console.log('error:' + e.message)
        }
    }

    renderBoundingBoxes=(mlresult)=>{
        console.log('render boxes');
        if (this.canvasRef && this.canvasRef.current && mlresult.localizedObjectAnnotations){
            for (var i=0; i<mlresult.localizedObjectAnnotations.length;i++ ){
               
                let localizedObjectAnnotation= mlresult.localizedObjectAnnotations[i];
                let ctx = this.canvasRef.current.getContext('2d');
                //ctx.setLineDash([2]);
                ctx.strokeStyle = 'rgba(0, 255, 0, 1)';
                //ctx.strokeRect(10,0,150,150);
                let width=500;
                let height=500;
                //ctx.stroke();
                let boundingPoly = localizedObjectAnnotation.boundingPoly;
                ctx.beginPath();
                ctx.moveTo(this.convertToFloat(boundingPoly.normalizedVertices[0].x) * width, this.convertToFloat(boundingPoly.normalizedVertices[0].y) * height);
                ctx.lineTo(this.convertToFloat(boundingPoly.normalizedVertices[1].x) * width, this.convertToFloat(boundingPoly.normalizedVertices[1].y) * height);

                ctx.moveTo(this.convertToFloat(boundingPoly.normalizedVertices[1].x) * width, this.convertToFloat(boundingPoly.normalizedVertices[1].y) * height);
                ctx.lineTo(this.convertToFloat(boundingPoly.normalizedVertices[2].x) * width, this.convertToFloat(boundingPoly.normalizedVertices[2].y) * height);

                ctx.moveTo(this.convertToFloat(boundingPoly.normalizedVertices[2].x) * width, this.convertToFloat(boundingPoly.normalizedVertices[2].y) * height);
                ctx.lineTo(this.convertToFloat(boundingPoly.normalizedVertices[3].x) * width, this.convertToFloat(boundingPoly.normalizedVertices[3].y) * height);
            
                ctx.moveTo(this.convertToFloat(boundingPoly.normalizedVertices[3].x) * width, this.convertToFloat(boundingPoly.normalizedVertices[3].y) * height);
                ctx.lineTo(this.convertToFloat(boundingPoly.normalizedVertices[0].x) * width, this.convertToFloat(boundingPoly.normalizedVertices[0].y) * height);
               // text
                ctx.stroke();

                let bottomLeftX = this.convertToFloat(boundingPoly.normalizedVertices[3].x) *  width;
                let bottomRightX= this.convertToFloat(boundingPoly.normalizedVertices[2].x) *  width;
                let textVertoffsetY = this.convertToFloat(boundingPoly.normalizedVertices[3].y) *  height -5;
                let labelCenterX =bottomLeftX + ((bottomRightX-bottomLeftX) * .5); // find the bottom center
                
                ctx.font = "12px Ariel";
                ctx.strokeText(localizedObjectAnnotation.name, labelCenterX, textVertoffsetY);
            }

           
        }else{
            console.log('not ready');
        }
    }

    renderTextBoundingBoxes=(mlresult)=>{
       
        if (this.canvasRef && this.canvasRef.current && mlresult.textAnnotations){
            let ctx = this.canvasRef.current.getContext('2d');
           
            for (var i=1; i<mlresult.textAnnotations.length;i++ ){
              
                let textObject= mlresult.textAnnotations[i];
                
               
                //ctx.stroke();
                let boundingPoly = textObject.boundingPoly;
                ctx.beginPath();
                 //ctx.setLineDash([2]);
                 ctx.fillStyle = 'black';
                 //ctx.strokeRect(10,0,150,150);
                // ctx.strokeStyle = 'rgba(255, 255, 0, 1)';

                ctx.moveTo(this.convertToFloat(boundingPoly.vertices[0].x), this.convertToFloat(boundingPoly.vertices[0].y));
                ctx.lineTo(this.convertToFloat(boundingPoly.vertices[1].x), this.convertToFloat(boundingPoly.vertices[1].y));

                //ctx.moveTo(this.convertToFloat(boundingPoly.vertices[1].x) , this.convertToFloat(boundingPoly.vertices[1].y) );
                ctx.lineTo(this.convertToFloat(boundingPoly.vertices[2].x) , this.convertToFloat(boundingPoly.vertices[2].y) );

                //ctx.moveTo(this.convertToFloat(boundingPoly.vertices[2].x) , this.convertToFloat(boundingPoly.vertices[2].y) );
                ctx.lineTo(this.convertToFloat(boundingPoly.vertices[3].x) , this.convertToFloat(boundingPoly.vertices[3].y) );
            
                //ctx.moveTo(this.convertToFloat(boundingPoly.vertices[3].x) , this.convertToFloat(boundingPoly.vertices[3].y) );
                ctx.lineTo(this.convertToFloat(boundingPoly.vertices[0].x) , this.convertToFloat(boundingPoly.vertices[0].y) );
                ctx.closePath();
                ctx.fill();
            ctx.stroke();
            }
           
            
          
           
        }else{
            console.log('not ready');
        }
    }
    
    renderImageToCanvas=(base64Image)=>{
        var img = new Image();
        if (this.canvasRef && this.canvasRef.current){
            let ctx = this.canvasRef.current.getContext('2d');
            img.onload=()=>{
                ctx.drawImage(img,0,0);
                
            }
            img.src=base64Image;
           

        }else{
            console.log('no Canvas');
        }
        
       
    }

    

    convertToFloat=(stringVal)=>{
        try {
            if (stringVal){
                return parseFloat(stringVal);
            }else{
                return 0
            }
        }catch(e){
            return 0
        }
    }


    renderCameraOrImage=()=>{
        let videoConstraints = {
            width: WIDTH,
            height: HEIGHT,
            facingMode: "user",
            forceScreenshotSourceSize: true,
            deviceId : (this.state.deviceId) ? this.state.deviceId : ''
           
          };
        if (!this.state.base64Image){
                return( <Webcam
                    audio={false}
                    height={HEIGHT}
                    screenshotFormat="image/jpeg"
                    width={WIDTH}
                    videoConstraints={videoConstraints}
                >
                    {({ getScreenshot }) => (
                    <div className="text-center"><br/><button className="btn btn-outline-info" 
                    onClick={() => {
                        const imageSrc = getScreenshot()
                        //console.log(imageSrc);
                        this.setState({
                            base64Image:imageSrc
                        }, ()=>{
                            this.renderImageToCanvas(imageSrc);
                            this.processPhoto();
                        })
                    }}
                >
                    Process Photo
                </button>
            

                </div>
                    )}
                </Webcam>)
        }else{
          return(
            <div>

                    <canvas id="c" style={{transform: `scale(${this.state.scale})`}}  ref={this.canvasRef} width="500px" height="500px"></canvas>
                
                    <br/>
                
                 </div>
           ) 
        }
    }


    updateResults=()=>{
        if (this.props.update){
            this.props.update(
                {
                    base64Image: (this.state.protectFlag && this.canvasRef.current) ? this.canvasRef.current.toDataURL():this.state.base64Image,
                    title:this.state.title,
                    keywords:this.state.keywords
                }
            )
        }
    }
    clear=()=>{
        this.setState({base64Image:undefined, keywords:'', title:''})
    }

    renderProtectKeywords=()=>{
        if (this.state.protectFlag){
            return( <div className='row'>
            <Multiselect
                isObject={false}
                ref={this.multiselectCategoriesRef}
                showArrow={true}
                displayValue='name'
                options={this.state.kewordList} // Options to display in the dropdown
                selectedValues={this.state.selectedKeyWordList} // Preselected value to persist in dropdown
                onSelect={(selectedList, selectedItem) =>{
                  //console.log(selectedList);
                  this.setState({selectedKeyWordList:selectedList, title:selectedList.join(',')})
                }} // Function will trigger on select event
                onRemove={(selectedList, removedItem)=>{
                 // console.log(selectedList);
                  this.setState({selectedKeyWordList:selectedList, title:selectedList.join(',')})
                }} // Function will trigger on remove event
                style={{
                  chips: {
                  
                    fontSize: '1.2sem',
                    color:'white',
                    fontWeight:'bold'
                  },
                  multiselectContainer: {
                    color: 'black',
                    fontWeight:'bold'
                  },
                 
                }}
          />
            </div>)
        }
    }
    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }
    render(){

        

            return (

                <div>
                <h6>Capture Found Item Image</h6>
                <hr/>
                Device:
                <br/>
                <div className="form-group">
                    <div className='row'>
                    <div className='col-7'> {this.renderDeviceList()}</div>
                    <div className='col-5'> <Toggle id='protectFlag' labelRight="Protect Mode" checked={this.state.protectFlag} onToggle={value => this.setState({protectFlag:value})} /> </div>
                    </div>
                </div>


               
                <br/>
               
                {this.renderCameraOrImage()}
           
                <div className="form-group">
                    <div className='row'>
                        <div className='col-2'><h5>Title:</h5></div>
                        <div className='col-10 text-left'><h6>{this.state.title}</h6></div>
                    </div>
                  {this.renderProtectKeywords()}
                </div>
               

                <div className='row'>
                        <div className='col-6'> <button className="btn btn-outline-primary" onClick={()=>{this.clear()}}>Clear</button></div>
                        <div className='col-6 text-right'><button className="btn btn-outline-success" disabled={(!this.state.base64Image)} onClick={()=>{this.updateResults()}}>Apply</button></div>
                    </div>
  
               {this.renderToast()}
                </div>
                

            )
    } 
}
export default (Camera);